export const T = {
  en_GB: {
    settings: "Settings",
    portfolioCollections: "Portfolio Collections",
    defaultDescription: "Manage portfolios and products for this collection",
    documentation: "Documentation",
    active: "Active",
    error: "Error",
    failedToToggleActive: "Failed to update active state",
  },
  nb_NO: {
    settings: "Innstillinger",
    portfolioCollections: "Porteføljesamlinger",
    defaultDescription: "Administrer porteføljer og produkter for denne samlingen",
    documentation: "Dokumentasjon",
    active: "Aktiv",
    error: "Feil",
    failedToToggleActive: "Kunne ikke oppdatere aktiv-status",
  },
} as const;
